import { vi_web } from './vi_web'
import { listing_web } from './listing_web'
import { gallery } from './gallery'
import { premium_gallery } from './premiumGallery'
import { DEFAULT } from './default'

const settings = (object_name, custom_tag, orientation) => {
  let settings = {
    vi_web: vi_web(object_name, custom_tag, orientation),
    listing_web: listing_web(object_name, custom_tag, orientation),
    gallery: gallery(object_name, custom_tag, orientation),
    premium_gallery: premium_gallery(object_name, custom_tag, orientation),
    DEFAULT: DEFAULT(object_name, custom_tag, orientation)
  }

  return settings[custom_tag] || settings["DEFAULT"]
}

export default settings


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/Carousel/settings/index.js